export default __webpack_public_path__ + "static/media/greenMessageIcon.bba3ffc8.svg";